import React from "react";
import Layout from "../components/layout";

function ErrorPage() {
  return <div>Error!! Page!!</div>;
}

export default ErrorPage;
